import React from 'react'

export const NoOrdenRender = () => {
    return (<>
        <div className="tbl-cripto-item">
            <div className="row1">
                <div>No hay ordenes activas!</div>
            </div>
        </div>
    </>)
}
